import { apiClient } from '../lib/api';
import type { MenuCategory, Product, Menu, Offer } from '../types';

export const menuService = {
    getCategories: async (): Promise<MenuCategory[]> => {
        return apiClient.request<MenuCategory[]>('/menu-categories/');
    },

    getProducts: async (): Promise<Product[]> => {
        return apiClient.request<Product[]>('/products/');
    },

    getMenus: async (): Promise<Menu[]> => {
        return apiClient.request<Menu[]>('/menus/');
    },

    getOffers: async (): Promise<Offer[]> => {
        return apiClient.request<Offer[]>('/offers/');
    },

    getUpcomingOffers: async (): Promise<Offer[]> => {
        return apiClient.request<Offer[]>('/offers/upcoming/');
    },
};
